<template>
  <v-dialog
    :value="isOpen"
    max-width="800"
    @input="close()"
  >
    <policy-wizard ref="policyWizardDialog" :household="household" @on-save="updateSavedPolicy" />
    <v-card>
      <v-card-title class="text-center title justify-center">Choose a policy or add a new one</v-card-title>
      <v-card-text>
        <v-row class="justify-center">
          <v-col
            v-for="policy in policiesSorted"
            :key="'policy' + policy.id"
            cols="12"
            sm="6"
          >
            <policy-card
              :policy="policy"
              hide-delete
              @on-click="selectPolicy(policy)"
            />
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-col cols="6">
            <policy-card 
              :policy="{}" 
              @on-click="$refs.policyWizardDialog.open()"
              dense
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PolicyCard from '@/views/households/policies/Card'
import PolicyWizard from '@/views/households/policies/PolicyWizard'

export default {
  name: 'SelectPolicyDialog',
  props: {
    household: {
      type: Object,
      required: true
    },
    ignorePolicies: {
      type: Array,
      default: () => []
    }
  },
  components: {
    PolicyCard,
    PolicyWizard
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    policiesSorted() {
      let policies = JSON.parse(JSON.stringify(this.household.policies))
      policies = policies.filter(p => {

        return (!this.ignorePolicies.includes((p.id + '')) && !this.ignorePolicies.includes(parseInt(p.id)))
      })
      return policies
    }
  },
  methods: {
    open() {
      this.isOpen = true
    },
    close() {
      this.isOpen = false
    },
    selectPolicy(policy) {
      this.$emit('on-select', policy)
      this.close()
    },
    updateSavedPolicy (policy) {
      this.$emit('on-policy-updated', policy)
      this.$emit('on-select', policy)
      this.close()
    }
  }
}
</script>